import { render, staticRenderFns } from "./ns-order-instalments.vue?vue&type=template&id=e9cc7474&"
import script from "./ns-order-instalments.vue?vue&type=script&lang=js&"
export * from "./ns-order-instalments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports